/**
 * Minimal `classnames`-style joiner. Avoids pulling in a dependency for
 * something this small — filters falsy values and joins with a space.
 */
export function cx(...classes) {
    return classes.filter(Boolean).join(' ');
}
